import { render, staticRenderFns } from "./sign-form.vue?vue&type=template&id=6d4b2de4&"
import script from "./sign-form.vue?vue&type=script&lang=js&"
export * from "./sign-form.vue?vue&type=script&lang=js&"
import style0 from "./sign-form.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d4b2de4')) {
      api.createRecord('6d4b2de4', component.options)
    } else {
      api.reload('6d4b2de4', component.options)
    }
    module.hot.accept("./sign-form.vue?vue&type=template&id=6d4b2de4&", function () {
      api.rerender('6d4b2de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/approval/@fragment/sign-form.vue"
export default component.exports